// Helper pro porovnání skutečné výrobní ceny s plánovanou.
// Vrátí null pokud plán není definován (planned <= 0).

export function computeVariance(actualUnitCost, product) {
  const planned = Number(product?.planned_unit_cost || 0);
  const tolerance = Number(
    product?.cost_tolerance_pct ?? 15
  );
  if (!planned || planned <= 0) return null;
  const actual = Number(actualUnitCost || 0);
  const diff = actual - planned;
  const pct = (diff / planned) * 100;
  const overTolerance = Math.abs(pct) > tolerance;
  let level = "ok"; // "ok" = within tolerance, "warn" = over tolerance
  if (overTolerance) level = "warn";
  return {
    planned,
    tolerance,
    actual,
    diff,
    pct,
    overTolerance,
    level,
  };
}
